import React, {useEffect, useState} from "react";
import Spinner from "../../spinner/Spinner";
import {Alert, Link, Table, TableHead, TableRow, TableCell, TableBody, TableContainer} from "@mui/material";
import {subscriptionServices} from "../../../service/subscriptionService";
import {DownloadOutlined, ReceiptLongOutlined} from "@mui/icons-material";
import {SubscriptionCard, SubscriptionSectionTitle} from "./SubscriptionDesign";
import {getSettingsColors, SettingsEmptyState} from "../SettingsDesign";

export default function Invoices() {
    const [loading, setLoading] = useState(true);
    const [errorMsg, setErrorMsg] = useState("");
    const [invoices, setInvoices] = useState(null);

    useEffect(() => {
        async function fetchData() {
            setLoading(true);
            setErrorMsg("");
            await subscriptionServices.getInvoices().then((result) => {
                setInvoices(result);
            }).catch((error) => {
                setErrorMsg(error?.response?.data?.error);
            }).finally(() => {
                setLoading(false);
            });
        }

        if (invoices === null) {
            fetchData();
        }
    }, [invoices]);

    return <SubscriptionCard sx={{minHeight: 200}}>
        <SubscriptionSectionTitle icon={ReceiptLongOutlined} title="Invoices" description="View and download your subscription invoices."/>
        {loading && <Spinner overComponentBox size={32} noBackShadow/>}
        {errorMsg && <Alert variant="filled" severity="error" sx={{mb: 2}}>{errorMsg}</Alert>}
        {!loading && !errorMsg && <>
            <TableContainer sx={{maxHeight: 422, borderRadius: '8px'}}>
                <Table size="small" aria-label="Subscription invoices" sx={{
                    '& th': {bgcolor: theme => getSettingsColors(theme).inset, color: 'text.secondary', borderLeft: 0, fontSize: 12, py: 1.5},
                    '& td': {py: 1.75, fontSize: 13}, '& tr:last-child td': {borderBottom: 0}}}>
                    <TableHead><TableRow><TableCell>Date</TableCell><TableCell align="right">Paid</TableCell><TableCell align="right">Actions</TableCell></TableRow></TableHead>
                    <TableBody>{invoices?.map((invoice, index) => <TableRow key={index}>
                        <TableCell>{invoice.dateTime}</TableCell><TableCell align="right">€ {(invoice.amountPaid / 100).toFixed(2)}</TableCell>
                        <TableCell align="right"><Link href={invoice.pdf} rel="noreferrer" underline="hover"
                            sx={{display: 'inline-flex', alignItems: 'center', gap: 0.5, fontSize: 13, color: 'primary.main'}}>
                            <DownloadOutlined sx={{fontSize: 16}}/>Download
                        </Link></TableCell>
                    </TableRow>)}</TableBody>
                </Table>
            </TableContainer>
            {!invoices?.length && <SettingsEmptyState icon={ReceiptLongOutlined} title="No invoices yet" description="Your subscription invoices will appear here."/>}
        </>}
    </SubscriptionCard>;
}
